import { RequestCard } from '../contracts';
import axios, { AxiosError } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';
import { IRequestPlasticCardRequest } from '@lib/types';

export const RequestCardApi =
  (endpoint: string): RequestCard =>
  async (request: IRequestPlasticCardRequest) => {
    try {
      const config = { ...createAxiosConfig(endpoint) };
      const response = await axios.post(endpoint, request, config);

      LogCannon.blast('Request Card success');
      return Promise.resolve(response.data);
    } catch (e: any | AxiosError) {
      if (e.message === '') {
        return Promise.resolve({ status: 'cancel' });
      }

      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('Request Card error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'Request Card failed',
          ...errorResponse,
        },
      });
    }
  };
